// import React from 'react'

// const EditSalesPerson = () => {
//   return (
//     <div>EditSalesPerson</div>
//   )
// }

// export default EditSalesPerson

import React, { useEffect, useState } from "react";
import backicon from "../../../../../Assets/icons/backIcon.svg";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import DynamicForm from "../../../../customformComponent/customForm/DynamicForm";
import Loader from "../../../../customComponents/CustomLoader";
import axiosInstance from "../../../../services/api/API";
import ROUTES_NAVIGATION from "../../../../../routes/routes";

const EditSalesPerson = () => {
  const [formData, setFormData] = useState({});
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [roledd, setRoledd] = useState([]);
  const navigate = useNavigate();
  const authToken = localStorage.getItem("authToken");
  const location = useLocation();
  const { data } = location.state || {};

  console.log(data, "salespersoneditdata");

  const Token = localStorage.getItem("authToken");
  const userType = localStorage.getItem("UserType");
  const [userTypedd, setUserTypedd] = useState([]);
  console.log(data, "BusinessPartnerID");
  const businessPartnerId = localStorage.getItem("business_partner_id");
  const BUSINESSPARTNERID = data?.business_partner_id;
  const [dealer, setDealer] = useState([]);

  const [dealerOptions, setDealerOptions] = useState([]);

  useEffect(() => {
    fetchDealers();
  }, []);

  const fetchDealers = async () => {
    try {
      const response = await axiosInstance.post("/dealer/ddldealer", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const data = response?.data?.data?.data;

      const dealerOptions = data.map((dealer) => ({
        value: dealer.dealer_id,
        label: dealer.dealer_name,
      }));

      setDealerOptions(dealerOptions);
    } catch (error) {
      console.log(error);
    }
  };

  const handleFormSubmit = async (formData) => {
    console.log("formdatadealer", formData);

    const errors = {};
    let isValid = true;
    DealerInputs.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!formData[field.name]) {
          errors[field.name] = "This field is required";
          isValid = false;
        }
      }
    });
    if (!isValid) {
      setValidationErrors(errors);
      return;
    }

    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to update this sales person?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setLoading(true);
          const payload = {
            sales_person_name: formData.sales_person_name,
            contact_no: formData.contact_no,
            sales_person_address: formData.sales_person_address,
            email_id: formData.email_id,
            sales_person_code: formData.sales_person_code,
            pan: formData.pan,
            country_id: formData.country_id,
            state_id: formData.state_id,
            city_id: formData.city_id,
            sales_pin_code: formData.pincode,
            status: formData.status === true ? 1 : 0,
          };

          const response = await axiosInstance.patch(
            `/salesperson/update/${data.sales_person_id}`,
            payload,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${authToken}`,
              },
            }
          );
          Swal.fire({
            title: "Success",
            text: "Sales Person updated successfully!",
            icon: "success",
            confirmButtonText: "OK",
          }).then(() => {
            navigate("/admin/manage-sales-person/sales-person");
          });
        } catch (error) {
          console.error("Error updating dealer:", error);
          const errorMessage =
            error.response?.data?.message ||
            "An error occurred while processing your request.";
          Swal.fire({
            title: "Error",
            text: errorMessage,
            icon: "error",
            confirmButtonText: "OK",
          });
        } finally {
          setLoading(false);
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire({
          title: "Cancelled",
          text: "Your changes were not saved.",
          icon: "info",
          confirmButtonText: "OK",
        });
        setLoading(false);
      }
    });
  };

  const fetchDealerEdit = async () => {
    try {
      const response = await axiosInstance.get(
        `/salesperson/edit/${data.sales_person_id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Token}`,
          },
        }
      );
      const fetchedData = response.data.data;
      const transformedData = {
        business_partner_id: fetchedData.business_partner_id,
        dealer_code: fetchedData.dealer_code,
        sales_person_name: fetchedData.sales_person_name,
        sales_person_code: fetchedData.sales_person_code,
        engineer_desc: fetchedData.engineer_desc,
        contact_no: fetchedData.contact_no,
        sales_person_address: fetchedData.sales_person_address,
        email_id: fetchedData.email_id,
        tin: fetchedData.tin,
        pan: fetchedData.pan,
        gst: fetchedData.gst,
        // pincode:fetchedData.pincode,
        pincode: fetchedData.sales_pin_code,
        country_id: formData.country_id,
        state_id: formData.state_id,
        city_id: formData.city_id,
        // role_id: parseInt(fetchedData.role_id, 10),
        status: fetchedData.status === 1 ? true : false,
      };
      setFormData(transformedData);
      setDealer(fetchedData);
      console.log(formData, "HSNCODE DATA");
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchDealerEdit();
  }, []);
  const DealerInputs = [
    {
      name: "sales_person_code",
      label: "Sales Person Code",
      type: "text",
      // required: true,
      // disabled:true,
      gridClass: "col-lg-4",
      placeholder: "Enter Sales Person Code",
    },
    {
      name: "sales_person_name",
      label: "Sales Person Name",
      placeholder: "Enter Sales Person",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: {
        required: true,
        pattern: /^[A-Za-z0-9-\s]*$/,
        message: "Special symbols are not allowed",
        maxLength: 20,
      },
    },

    {
      name: "contact_no",
      label: "Contact No.",
      placeholder: "Enter Contact No.",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: {
        required: true,
        pattern: /^[6-9]/,
        minLength: 10,
        maxLength: 10,
        message1: "Contact No. should start with 6, 7, 8, 9",
        message: "Please enter a valid 10-digit Contact No.",
      },
    },
    {
      name: "sales_person_address",
      label: "Sales Person Address",
      placeholder: "Enter Sales Person Address",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true },
    },
    {
      name: "email_id",
      label: "Email ID",
      placeholder: "Enter Email Address",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: {
        required: true,
        pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        message: "Please enter a valid Email Address",
      },
    },

    {
      name: "pan",
      label: "PAN No.",
      type: "text",
      placeholder: "Enter Pan No.",
      validation: {
        // required: true,
        pattern: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
        message: "Please enter a valid 10-character PAN number",
        maxLength: 10,
      },
      // required: true,
      gridClass: "col-lg-4",
    },
    {
      name: "pincode",
      label: "Pin Code",
      placeholder: "Enter Pin Code",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true, maxLength: 6 },
    },
    {
      name: "city",
      label: "City",
      placeholder: "City",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      // validation: { required: true },
      disabled: true,
    },
    {
      name: "state",
      label: "State",
      placeholder: "State",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      // validation: { required: true },
      disabled: true,
    },
    {
      name: "country",
      label: "Country",
      placeholder: "Country",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      // validation: { required: true },
      disabled: true,
    },
    // {
    //   name: "role_id",
    //   label: "Role",
    //   type: "dropdown",
    //   options: roledd,
    //   required: true,
    //   gridClass: "col-lg-4",
    //   validation: { required: true },
    // },
    {
      name: "status",
      label: "Status",
      type: "toggle",
      // required: true,
      validation: { required: false },
    },
    // {
    //   name: "actions",
    //   label: "Actions",
    //   type: "multiselectdropdown",
    //   required: true,
    //   options: [
    //     { label: "Edit", value: "Edit" },
    //     { label: "Delete", value: "Delete" },
    //   ],
    //   gridClass: "col-lg-4",
    // },
  ];

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          <div className="backbutton mt-2 mb-2" onClick={() => navigate(-1)}>
            <img src={backicon} alt="back" />
            <span className="backbtntitle">Edit Sales Person</span>
          </div>
          <div className="form-container">
            <span className="cust-det-title mt-2 mb-2">
              Please Enter Sales Person Details
            </span>
            <DynamicForm
              formConfig={DealerInputs}
              formData={formData}
              setFormData={setFormData}
              onSubmit={handleFormSubmit}
              validationErrors={validationErrors}
              setValidationErrors={setValidationErrors}
            />
          </div>
          <div className="btncontainer mt-3">
            <button
              onClick={() => {
                  handleFormSubmit(formData); // Call handleFormSubmit if isFormSubmitted is false
              }}
              className="submit-btn"
            >
              Submit
            </button>
          </div>
        </>
      )}
    </>
  );
};

export default EditSalesPerson;
